var render = function render(){var _vm=this,_c=_vm._self._c;return _c('erp-s-field',{attrs:{"view":"lr","label":"Sigla:"}},[_c('erp-input',{staticClass:"text-positive",attrs:{"simple-border":"","loading":_vm.isVerificandoSigla},model:{value:(_vm.inptVal),callback:function ($$v) {_vm.inptVal=$$v},expression:"inptVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }